export class SaveAnswerViewModel {
    callId: string = "";
    completeId: number = 0;
    questionId: number = 0;
    answerContent: string = "";
    constructor(callId: string, completeId: number, questionId: number, answerContent: string) {
        this.callId = callId;
        this.completeId = completeId;
        this.questionId = questionId;
        this.answerContent = answerContent;
    }
}